"use client"
import {numberWithCommas} from "@/lib/numberWithCommas/numberWithCommas";
// import { formatWithSubscript } from "@/app/hooks/market/useFormatWithSubscript";
import React, {useEffect, useState} from "react";

interface ExchangeValuesProps {
    data: ExchengesType
}

export const ExchangeValues: React.FC<ExchangeValuesProps> = ({data}) => {
    const [bitPrice, setBitPrice] = useState<null | number>(null)

    useEffect(() => {
        setBitPrice(localStorage?.getItem('bitPrice') ? +(localStorage?.getItem('bitPrice') as string) : null)
    }, []);

    console.log()
    if (!bitPrice) {
        return null
    }

    return <>
        {/* <p className="text-right hidden md:block"><p dangerouslySetInnerHTML={{ __html: `$${formatWithSubscript(data?.tradeVolume24hBtcNormalized * bitPrice?.toFixed(0))}` }}></p></p>
        <p className="text-right "><p dangerouslySetInnerHTML={{ __html: `$${formatWithSubscript(data?.tradeVolume24hBtc * bitPrice?.toFixed(0))}` }}></p></p> */}
        <p className="text-right hidden md:block">${numberWithCommas(Number(data?.tradeVolume24hBtcNormalized * bitPrice)?.toFixed(0))}</p>
        <p className="text-right ">${numberWithCommas(Number(data?.tradeVolume24hBtc * bitPrice)?.toFixed(0))}</p>
    </>
}